import { render, staticRenderFns } from "./SingleTag.vue?vue&type=template&id=c85ae018&scoped=true"
import script from "./SingleTag.vue?vue&type=script&lang=js"
export * from "./SingleTag.vue?vue&type=script&lang=js"
import style0 from "./SingleTag.vue?vue&type=style&index=0&id=c85ae018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85ae018",
  null
  
)

export default component.exports